import script from "./AmenityList.vue?vue&type=script&setup=true&lang=js"
export * from "./AmenityList.vue?vue&type=script&setup=true&lang=js"

import "./AmenityList.vue?vue&type=style&index=0&id=0690c98b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0690c98b"]])

export default __exports__